module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium.3acff790.woff";